// Steps: Actions triggered for each step/next button within the application.
import { Dispatch } from 'redux';

import { AppActions, actionTypes } from '../types';

/* Types */
type Action<T> = import('../types').Action<T>;

export interface OpenStepAction extends Action<typeof actionTypes.OPEN_STEP> {
    type: typeof actionTypes.OPEN_STEP;
    payload: number;
}

export interface UpdateStepsCompletionAction extends Action<typeof actionTypes.UPDATE_STEPS_COMPLETION> {
    type: typeof actionTypes.UPDATE_STEPS_COMPLETION;
}

export type StepsActions = OpenStepAction | UpdateStepsCompletionAction;

export const openStep = (step: number): OpenStepAction => ({
    type: actionTypes.OPEN_STEP,
    payload: step,
});

export const updateStepsCompletion = (): UpdateStepsCompletionAction => ({
    type: actionTypes.UPDATE_STEPS_COMPLETION,
});

export const updateStepsCompletionFetch =
    () =>
    async (dispatch: Dispatch<AppActions>): Promise<void> => {
        await dispatch(updateStepsCompletion());
    };
